import Backbone from 'backbone';
import Cache from 'root/cache';
import Util from 'root/module/util';

export default Backbone.Model.extend({
    defaults: {
        account_id        : 0,
        project_id        : 0,
        user_id           : 0,
        portal_user_id    : 0,
        feedback_id       : 0,
        screenshot_num    : 0,
        reply_comment_id  : 0,
        is_resolved       : false,
        is_public         : false,
        anon_email        : '',
        anon_name         : '',
        comment           : '',
        attachment        : '',
        screen_x          : 0,
        screen_y          : 0,
        annotation_type   : '',
        start_x           : 0,
        start_y           : 0,
        screen_number     : 0,
        video_number      : 0,
        video_time        : 0,
        reaction          : '',
        time              : 0,
        last_edit_time    : 0,
        source            : ''
    },

    getDisplayInfo: function() {
        var user = Cache.user.get(this.get('user_id'));

        var gravatar_name     = user ? user.get('name') : this.get('anon_name');
        var gravatar_email    = user ? user.get('email') : this.get('anon_email');
        var gravatar_fallback = '';

        if (this.get('user_id') && !user) {
            if (Cache.real_user_id) {
                gravatar_name     = 'Deleted user';
                gravatar_email    = '';
                gravatar_fallback = '/image/profile.png';
            } else {
                gravatar_name = '';
            }
        }

        return {
            name     : gravatar_name,
            email    : gravatar_email,
            fallback : gravatar_fallback
        };
    },

    getDisplayName: function(include_email, include_name, html_entities) {
        if (typeof html_entities === 'undefined') {
            html_entities = true;
        }

        var display_info = this.getDisplayInfo();
        var display_name = '';

        if (Cache.real_user_id) {
            if (include_email && include_name) {
                display_name = display_info.name + (display_info.email ? ' (' + display_info.email + ')' : '');
            } else if (include_email) {
                display_name = display_info.email;
            } else if (include_name) {
                display_name = display_info.name;
            }
        } else {
            display_name = display_info.name;
        }

        if (html_entities === true) {
            return Util.htmlEntities(display_name);
        } else {
            return display_name;
        }
    },

    getAvatar: function(size) {
        var user = Cache.user.get(this.get('user_id'));
        var display_info = this.getDisplayInfo();

        size = size || 32;

        if (user) {
            return user.getAvatar(size);
        } else if (display_info.fallback) {
            return display_info.fallback;
        } else {
            return Util.gravatar(display_info.email, size, display_info.name);
        }
    }
});